import { Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { MemberMe } from 'src/modules/member/models/member';
import { useTranslation } from 'react-i18next';
import { RootState } from '../services/store';
import { RoutesEnum } from '../models/enums/routes.enum';
import { useGlobals } from '../contexts/appContext';
import { getMemberSettings } from '../services/memberService';
import ConsoleHelper from '../functions/consoleHelper';
import { UserAccountTypeEnum } from '../models/enums/userAccountType.enum';
import { SystemMessageTypeEnum } from '../models/enums/systemMessageType.enum';

const RequireMember = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.oidc.user);
  const { setCurrentMember, setSystemMessage } = useGlobals();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMember = async () => {
      const result = await getMemberSettings();
      const memberResult = result.data as MemberMe;
      setCurrentMember(memberResult);
      const countUnpaidInvoices = memberResult.currentInvoices?.filter((x) => x.paid === 0) || [];
      if (countUnpaidInvoices?.length > 0) {
        setSystemMessage({
          height: 40,
          message:
            countUnpaidInvoices.length === 1
              ? t('common:statusMessages.unPaidInvoice')
              : t('common:statusMessages.unPaidInvoices', { count: countUnpaidInvoices.length }),
          hideable: true,
          type: SystemMessageTypeEnum.UserMessage,
        });
      }

      ConsoleHelper.log('Member/ME', result.data);
      setIsLoading(false);
    };
    if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.Member) {
      fetchMember();
    } else {
      setIsLoading(false);
    }
  }, [user, setCurrentMember, setSystemMessage, t]);

  if (isLoading) {
    return <div />;
  }
  if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.Member) {
    return <Suspense fallback={<div />}>{children}</Suspense>;
  }
  if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.User) {
    return <Navigate to={RoutesEnum.Dashboard} state={{ from: location }} replace />;
  }
  return <Navigate to={RoutesEnum.Login} state={{ from: location }} replace />;
};

export default RequireMember;
